import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import More from 'wix-ui-icons-common/More';
import { IconButton, PopoverMenu } from 'wix-style-react';
var FieldActionsMenu = /** @class */ (function (_super) {
    __extends(FieldActionsMenu, _super);
    function FieldActionsMenu(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    FieldActionsMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, actions = _a.actions, dataHook = _a.dataHook, t = _a.t;
        if (!actions || !actions.length) {
            return null;
        }
        return (React.createElement(PopoverMenu, { dataHook: dataHook + "-actions", placement: "top", zIndex: 6000, triggerElement: React.createElement(IconButton, { dataHook: dataHook + "-actions-trigger", skin: "light", size: "small" },
                React.createElement(More, null)) }, actions.map(function (action) { return (React.createElement(PopoverMenu.MenuItem, { key: action.name, dataHook: dataHook + "-" + action.name, text: t("editContact.moreActions." + action.name), onClick: function () { return _this.props.onActionClicked(action); } })); })));
    };
    return FieldActionsMenu;
}(React.PureComponent));
export default translate()(FieldActionsMenu);
//# sourceMappingURL=FieldActionsMenu.js.map